import { render, staticRenderFns } from "./home-in-salabam.vue?vue&type=template&id=1dcc24e8&"
import script from "./home-in-salabam.vue?vue&type=script&lang=js&"
export * from "./home-in-salabam.vue?vue&type=script&lang=js&"
import style0 from "./home-in-salabam.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports